import React from "react";

const SendMessage = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M33.973 2.852c.037.188.034.387 0 .586-.083.498-.175.994-.247 1.494-.41 2.85-.814 5.701-1.222 8.551l-1.215 8.52c-.33 2.303-.656 4.607-.996 6.91a1.2 1.2 0 01-.233.552c-.342.424-.777.424-1.25.255-4.511-1.611-9.024-3.217-13.535-4.825-.072-.026-.142-.062-.24-.104L28.433 7.97a.33.33 0 00-.24.097C22.548 13.098 16.9 18.13 11.258 23.166c-.184.163-.333.187-.555.107-2.563-.92-5.127-1.84-7.696-2.741-.444-.155-.808-.37-1.006-.827v-.52c.135-.342.353-.59.676-.765 5.444-2.955 10.886-5.916 16.328-8.877l13.72-7.472c.18-.059.3-.106.527-.035.351.178.643.415.722.816zM13.688 26.53c1.791.637 3.565 1.268 5.362 1.909-.042.078-.07.143-.11.2-1.143 1.623-2.283 3.248-3.434 4.866-.487.685-1.368.653-1.721-.057a1.157 1.157 0 01-.117-.495c-.008-2.079-.006-4.159-.005-6.237 0-.053.013-.105.025-.187z"
            fill={fill}
        />
    </svg>
);

export default SendMessage;
